// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import {useDispatch, useSelector } from "react-redux";
// import "./DepositEmi.css";
// import { useRef } from 'react';
// import { useReactToPrint } from 'react-to-print';
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

// const DepositEmiList = () => {
//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch=useDispatch();
//   const [company, setCompany] = useState(null);

//   const slipRef = useRef(null);
//   const [selectedAcc, setSelectedAcc] = useState(null);
//   const [selectedEmi,setSelectedEmi]= useState(null);

//   const { id } = useParams();
//   const accountId = id;

//   const [account, setAccount] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const [showDialog, setShowDialog] = useState(false);

//   const [collectionDate, setCollectionDate] = useState(
//     new Date().toISOString().split("T")[0]
//   );
//   const [collectionMode, setCollectionMode] = useState("Cash");
//   const [amount, setAmount] = useState("");
//   const [remarks, setRemarks] = useState("");
//   const [payLoading, setPayLoading] = useState(false);

//   console.log(account)

//   // ============= FETCH ACCOUNT INSTALLMENTS =============
//   const fetchData = async () => {
//     try {
//       const res = await axios.get(`https://narrowitsolution.in/api/deposit/${accountId}`);
//       if (res.data?.success) setAccount(res.data.data);
//     } catch (err) {
//       alert("Failed to load EMI schedule");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ============= FETCH COMPANY DETAILS =============
//   // useEffect(() => {
//   //   const fetchCompany = async () => {
//   //     try {
//   //       const res = await fetch(
//   //         `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
//   //       );
//   //       const data = await res.json();
//   //       console.log("company data:",data)
//   //       if (res.ok && data) {
//   //         if (data.logo) {
//   //           data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
//   //         }
//   //         setCompany(data);
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching company:", err);
//   //     }
//   //   };

//   //   if (profile?.superAdminId) fetchCompany();
//   // }, [profile]);

//   // useEffect(() => {
//   //   const fetchCompany = async () => {
//   //     try {
//   //       const res = await fetch(
//   //         `https://narrowitsolution.in/api/get-company?superAdminId=14`
//   //       );
//   //       const data = await res.json();
//   //       console.log("company data:",data)
//   //       if (res.ok && data) {
//   //         if (data.logo) {
//   //           data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(
//   //             /^images\//,
//   //             ""
//   //           )}`;
//   //         }
//   //         setCompany(data);
//   //         console.log(company);
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching company:", err);
//   //     }
//   //   };

//   //   if (profile?.superAdminId) fetchCompany();
//   // }, [profile]);

//   useEffect(() => {
//     fetchData();
//   }, [accountId]);

//   // ============= DOWNLOAD SLIP FUNCTION =============
//   const downloadSlip = async (emi, account) => {

//     const { jsPDF } = await import("jspdf");
//     const html2canvas = (await import("html2canvas")).default;

//     const slip = document.createElement("div");
//     slip.style.width = "700px";
//     slip.style.padding = "30px";
//     slip.style.fontFamily = "Arial";
//     slip.style.background = "#fff";
//     slip.style.border = "1px solid #ddd";
//     slip.style.borderRadius = "8px";

//     let logoHTML = company?.logoUrl
//       ? `<img src="${company.logoUrl}" style="height:80px; margin-bottom:10px;" />`
//       : "";

//     slip.innerHTML = `
//       <div style="text-align:center; border-bottom:2px solid #0a59a0; padding-bottom:15px; margin-bottom:20px;">
//         ${logoHTML}

//       </div>

//       <h3 style="text-align:center; margin-bottom:20px;">Deposit Payment Slip</h3>

//       <table style="width:100%; font-size:15px;">
//         <tr>
//           <td><strong>Customer Name:</strong></td>
//           <td>${account.customerName}</td>
//           <td><strong>Paid Date:</strong></td>
//           <td>${
//             emi.collectionDate
//               ? new Date(emi.collectionDate).toLocaleDateString()
//               : "-"
//           }</td>
//         </tr>
//         <tr>
//           <td><strong>Account No:</strong></td>
//           <td>${account.accountNo}</td>
//           <td><strong>Due Date:</strong></td>
//           <td>${new Date(emi.dueDate).toLocaleDateString()}</td>
//         </tr>
//         <tr>
//           <td><strong>EMI No:</strong></td>
//           <td>${emi.installmentNo}</td>
//           <td><strong>Mode:</strong></td>
//           <td>${emi.collectionType || "-"}</td>
//         </tr>
//       </table>

//       <hr style="margin:20px 0;">

//       <table style="width:100%; font-size:16px;">
//         <tr>
//           <td><strong>EMI Amount:</strong></td>
//           <td>₹${emi.amount}</td>
//         </tr>
//         <tr>
//           <td><strong>Status:</strong></td>
//           <td>${emi.status}</td>
//         </tr>

//       </table>

//       <p style="margin-top:40px; font-size:13px; color:#666; text-align:center;">
//         This is a system-generated Deposit slip. No signature required.
//       </p>
//     `;

//     document.body.appendChild(slip);

//     const canvas = await html2canvas(slip, { scale: 3 });
//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF("p", "mm", "a4");
//     pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
//     pdf.save(`Deposit${account.accountNo}_EMI${emi.installmentNo}.pdf`);

//     document.body.removeChild(slip);
//   };

//   // ============= UI RENDERING =============
//   if (loading) return <p>Loading...</p>;
//   if (!account) return <p>No account found</p>;
//   //  console.log("account data",account);

//   return (
//     <div className="emi-container">
//       <h2>Deposit Installment Schedule</h2>

//       <p>
//         <strong>Account No:</strong> {account.accountNo}
//       </p>
//       <p>
//         <strong>Account Type:</strong> {account.accountType}
//       </p>
//       <p>
//         <strong>Customer:</strong> {account.customerName}
//       </p>

//       <table className="emi-table">
//         <thead>
//           <tr>
//             <th>Installment No</th>
//             <th>Due Date</th>
//             <th>Paid Date</th>
//             <th>Amount</th>
//             <th>Status</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//         <tbody>
//           {account.installments?.length > 0 ? (
//             account.installments.map((emi) => (
//               <tr
//                 key={emi.id}
//                 className={emi.status === "Paid" ? "emi-paid" : "emi-pending"}
//               >
//                 <td>{emi.installmentNo}</td>
//                 <td>{new Date(emi.dueDate).toLocaleDateString()}</td>
//                 <td>
//                   {emi.collectionDate
//                     ? new Date(emi.collectionDate).toLocaleDateString()
//                     : "-"}
//                 </td>
//                 <td>₹{emi.amount}</td>
//                 <td>{emi.status}</td>

//                 <td>
//                   {emi.status === "Pending" ? (
//                     <button
//                       className="pay-btn"
//                       onClick={() => {
//                         setSelectedEmi(emi);
//                         setShowDialog(true);
//                       }}
//                     >
//                       Pay EMI
//                     </button>
//                   ) : (
//                     <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
//                       <button className="download-btn"
//                               onClick={() => {
//                                 downloadSlip(emi,account);
//                               }}
//                         >Download</button>

//                       <button
//                         className="download-btn"
//                          onClick={() => {
//                           setSelectedEmi(emi);
//                           setSelectedAcc(account);
//                            printOrDownloadThermalSlip();
//                         }}>
//                         Print
//                       </button>

//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="6" style={{ textAlign: "center" }}>
//                 No Installments Found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* PAYMENT POPUP */}
//       {showDialog && selectedEmi && (
//         <div className="emi-dialog-overlay">
//           <div className="emi-dialog-box">
//             <h3>Pay Installment</h3>

//             <p>
//               <strong>Installment No:</strong> {selectedEmi.installmentNo}
//             </p>
//             {selectedEmi?.amount ? (
//               <p>
//                 <strong>Amount:</strong> ₹{selectedEmi.amount}
//               </p>
//             ) : (
//               ""
//             )}
//             <p>
//               <strong>Due Date:</strong>{" "}
//               {new Date(selectedEmi.dueDate).toLocaleDateString()}
//             </p>

//             <div className="dialog-form">
//               <label>Collection Date:</label>
//               <input
//                 type="date"
//                 value={collectionDate}
//                 onChange={(e) => setCollectionDate(e.target.value)}
//               />

//               <label>Collection Mode:</label>
//               <select
//                 value={collectionMode}
//                 onChange={(e) => setCollectionMode(e.target.value)}
//               >
//                 <option value="Cash">Cash</option>
//                 <option value="UPI">UPI</option>
//                 <option value="Bank">Bank</option>
//                 <option value="Auto">Auto (Linked)</option>
//               </select>

//               <label>Amount:</label>
//               {selectedEmi?.amount ? (
//                 <input type="text" value={selectedEmi.amount} readOnly />
//               ) : (
//                 <input
//                   type="text"
//                   value={amount}
//                   placeholder="Enter Amount"
//                   onChange={(e) => setAmount(e.target.value)}
//                 />
//               )}

//               <label>Remarks:</label>
//               <input
//                 type="text"
//                 placeholder="Remarks (optional)"
//                 value={remarks}
//                 onChange={(e) => setRemarks(e.target.value)}
//               />
//             </div>

//             <div className="dialog-actions">
//               <button
//                 className="confirm-btn"
//                 disabled={payLoading}
//                 onClick={async () => {
//                   try {
//                     setPayLoading(true);

//                     const payload = {
//                       accountId: account.id,
//                       installmentNo: selectedEmi.installmentNo,
//                       ...(account.accountType === "DD" && {
//                         userAmount: amount,
//                       }),
//                       collectionDate,
//                       collectionMode,
//                       collectedBy: localStorage.getItem("userId") || 1,
//                       remarks,
//                     };

//                     const url ="https://narrowitsolution.in/api/deposit/pay-installment";
//                       // account.accountType === "RD"
//                       //   ? "https://narrowitsolution.in/api/deposit/pay-installment"
//                       //   : "https://narrowitsolution.in/api/deposit/pay-installment-custom";

//                     const res = await axios.post(url, payload);

//                     if (res.data.success) {
//                       alert("Installment Paid Successfully!");
//                       setShowDialog(false);
//                       fetchData();
//                     } else {
//                       alert(res.data.message);
//                     }
//                   } catch (err) {
//                     alert("Payment failed");
//                   } finally {
//                     setPayLoading(false);
//                   }
//                 }}
//               >
//                 {payLoading ? "Processing..." : "Pay Now"}
//               </button>

//               <button
//                 className="cancel-btn"
//                 onClick={() => setShowDialog(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//         {/*  Hidden Thermal Slip (thermal printer format) */}
//           <div style={{ position: "absolute", left: "-10000px" }}>
//             <div
//               ref={slipRef}
//               style={{
//                 width: "230px",           // 58mm thermal printer width
//                 padding: "10px",
//                 border:"1px solid #ccc",
//                 fontFamily: "Courier New, monospace",
//                 fontSize: "12px",
//                 lineHeight: "1.2",
//               }}
//             >
//               <div style={{ textAlign: "center"}}>
//                   <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "14px" }}>
//                     {company?company.name:"--"}
//                   </div>
//                   {/* <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
//                     <b>Company CIN:</b> {company?company.cin:"--"}
//                   </div> */}
//                   <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
//                     <b>Contact No.:</b> {company?company.contact:"--"}
//                   </div>
//                   <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
//                     <b>Address.:</b> {company?company.address:"--"}
//                   </div>
//               </div>

//               <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>

//               <div><b>Account No:</b> {selectedAcc?.accountNo}</div>
//               <div><b>Name:</b> {selectedAcc?.customerName || "--"}</div>
//               <div><b>Opening Date:</b> {selectedAcc?.openingDate ? new Date(selectedAcc.openingDate).toLocaleDateString():"--"}</div>
//               <div><b>Due Date:</b> {selectedEmi?.dueDate ? new Date(selectedEmi.dueDate).toLocaleDateString() : "--"}</div>
//               <div><b>Paid Date:</b> {selectedEmi?.collectionDate ? new Date(selectedEmi.collectionDate).toLocaleDateString() : "--"}</div>
//               <div><b>EMI No:</b> {selectedEmi?.installmentNo || "--"}</div>
//               <div><b>Mode:</b> {selectedEmi?.collectionType || "--"}</div>
//               <div><b>EMI Amount:</b> ₹{selectedEmi?.amount || "--"}</div>
//               <div><b>Status:</b> {selectedEmi?.status || "--"}</div>
//               <div><b>Recieved By:</b> {profile?.fullName ||"--"}</div>
//               <div><b>agent Id:</b> {profile?.userId ||"--"}</div>
//               <div><b>Branch:</b> {profile?.bankBranch ||"--"}</div>

//               <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>

//               <div style={{ textAlign: "center" }}>Thank you!</div>
//               <div style={{ textAlign: "center" }}>--- {company ? company.name.split(" ")[0] : "--"} Slip ---</div>
//             </div>
//           </div>
//     </div>
//   );
// };

// export default DepositEmiList;






import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./DepositEmi.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

const DepositEmiList = () => {
  const { profile } = useSelector((state) => state.userProfile);
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const accountId = id;

  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showDialog, setShowDialog] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);

  const [collectionDate, setCollectionDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [collectionMode, setCollectionMode] = useState("Cash");
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [payLoading, setPayLoading] = useState(false);

  const slipRef = useRef(null);

  console.log(account);

  // ============= FETCH ACCOUNT INSTALLMENTS =============
  const fetchData = async () => {
    try {
      const res = await axios.get(`https://narrowitsolution.in/api/deposit/${accountId}`);
      if (res.data?.success) setAccount(res.data.data);
    } catch (err) {
      toast.error("Failed to load EMI schedule");
    } finally {
      setLoading(false);
    }
  };

  // ============= FETCH COMPANY DETAILS =============
  // useEffect(() => {
  //   const fetchCompany = async () => {
  //     try {
  //       const res = await fetch(
  //         `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
  //       );
  //       const data = await res.json();
  //       console.log("company data:", data);
  //       if (res.ok && data) {
  //         if (data.logo) {
  //           data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(
  //             /^images\//,
  //             ""
  //           )}`;
  //         }
  //         setCompany(data);
  //       }
  //     } catch (err) {
  //       console.error("Error fetching company:", err);
  //     }
  //   };

  //   if (profile?.superAdminId) fetchCompany();
  // }, [profile]);


    useEffect(() => {
    // const fetchCompany = async () => {
    //   try {
    //     const res = await fetch(
    //       `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
    //     );
    //     const data = await res.json();
    //     const info = data.data || data;
    //     console.log("company data",info)

    //     if (info.logo)
    //       info.logoUrl = `https://narrowitsolution.in/${info.logo.replace(/^images\//, "")}`;

    //     setCompany(info);
    //   } catch (err) {
    //     console.log("Company fetch error", err);
    //   }
    // };

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };
    fetchCompany();
  }, [profile?.superAdminId]);

  useEffect(() => {
    fetchData();
  }, [accountId]);


const downloadSlip = (emi, account) => {
  const doc = new jsPDF("p", "pt", "a5");
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let y = margin;

  // 🖼 Logo
  try {
    if (company?.logoUrl) {
      doc.addImage(company.logoUrl, "PNG", margin, y, 50, 50);
    }
  } catch (err) {
    console.warn("Logo load failed");
  }

  // 🏢 Company Info
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(company?.name || "Company Name", margin + 60, y + 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`Address: ${company?.address || "-"}`, margin + 60, y + 40);

  y += 70;
  doc.line(margin, y, pageWidth - margin, y);
  y += 20;

  // 🧾 Slip Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text("Deposit Payment Slip", pageWidth / 2, y, { align: "center" });

  y += 20;

  // 👤 Customer Details
  doc.setFontSize(10);
  doc.text("Customer Details", margin, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    theme: "plain",
    styles: { fontSize: 9, cellPadding: 3 },
    body: [
      [`Customer Name : ${account?.customerName || "-"}`],
      [`Account Number : ${account?.accountNo || "-"}`],
      [`EMI Number : ${emi?.installmentNo || "-"}`],
    ],
  });

  y = doc.lastAutoTable.finalY + 15;

  // 💳 Transaction Details
  doc.setFont("helvetica", "bold");
  doc.text("Transaction Details", margin, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    theme: "plain",
    styles: { fontSize: 9, cellPadding: 3 },
    body: [
      [
        `EMI Amount : Rs. ${emi?.amount?.toLocaleString() || "-"}`,
        `Due Date : ${
          emi?.dueDate ? new Date(emi.dueDate).toLocaleDateString() : "-"
        }`,
      ],
      [
        `Paid Date : ${
          emi?.collectionDate
            ? new Date(emi.collectionDate).toLocaleDateString()
            : "-"
        }`,
        `Mode : ${emi?.collectionType || "-"}`,
      ],
      [
        `Status : ${emi?.status || "-"}`,
        "",
      ],
    ],
  });

  // 💾 Save
  doc.save(
    `Deposit_${account?.loanNumber || "Account"}_EMI${emi?.installmentNo}.pdf`
  );
};


  const printOrDownloadThermalSlip = async () => {
    if (!slipRef.current) return;

    const { jsPDF } = await import("jspdf");
    const html2canvas = (await import("html2canvas")).default;

    // 1️⃣ Render slip to canvas
    const canvas = await html2canvas(slipRef.current, {
      scale: 3,
      backgroundColor: "#ffffff",
    });
    const imgData = canvas.toDataURL("image/png");

    // 2️⃣ Prepare PDF (thermal size)
    const pdfWidth = 58; // mm
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [pdfWidth, imgHeight],
    });
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

    // 3️⃣ Try to open print window
    try {
      const printWindow = window.open("", "_blank", "width=1000,height=600");

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Slip</title>
            <style>
              @page { size: 58mm auto; margin:0; }
              body { margin:0; padding:0; text-align:center; }
              img { width:58mm; max-width:58mm; }
            </style>
          </head>
          <body>
            <img src="${imgData}" />
          </body>
        </html>
      `);

      printWindow.document.close();

      // Wait for print window to load
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        // Optional: close after printing
        setTimeout(() => printWindow.close(), 500);
      };
    } catch (err) {
      // 4️⃣ Fallback → Download PDF
      pdf.save(`EMI_Slip_${selectedEmi?.accountNo}.pdf`);
    }
  };

  // ============= UI RENDERING =============
  if (loading) return <p>Loading...</p>;
  if (!account) return <p>No account found</p>;

  return (
    <div className="emi-container">
     <div className="emi-container-header">
          <h2>Deposit Installment Schedule</h2>

          <p>
            <strong>Account No:</strong> {account.accountNo}
          </p>
          <p>
            <strong>Account Type:</strong> {account.accountType}
          </p>
          <p>
            <strong>Customer:</strong> {account.customerName}
          </p>
          <p>
            <strong>Scheme Name:</strong> {account.schemeName}
          </p>
          
      </div>

    <div className="emi-table-container">
      <table className="emi-table">
        <thead>
          <tr>
            <th>Installment No</th>
            <th>Due Date</th>
            <th>Paid Date</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {account?.installments?.length > 0 ? (
            account.installments.map((emi,i) => {
              const nextemi=i<account?.installments?.length-1?account?.installments[i+1]:null;
              return(
              <tr
                key={emi.id}
                className={emi.status === "Paid" ? "emi-paid" : "emi-pending"}
              >
                <td>{emi.installmentNo}</td>

                <td>{new Date(emi.dueDate).toLocaleDateString("en-GB")}</td>

                <td>
                  {emi.collectionDate
                    ? new Date(emi.collectionDate).toLocaleDateString("en-GB")
                    : "-"}
                </td>

                <td>₹{emi.amount}</td>
                <td>{emi.status}</td>

                <td>
                  {emi.status === "Pending" ? (
                    <button
                      className="deposit-pay-btn"
                      onClick={() => {
                        setSelectedEmi(emi);
                        setShowDialog(true);
                      }}
                    >
                      Pay EMI
                    </button>
                  ) : (
                    <div style={{ display: "flex",justifyContent:"center",alignItems:"center", gap: "5px" }}>
                      {/* <button
                        className="download-btn"
                        onClick={() => downloadSlip(emi, account)}
                      >
                        Download
                      </button>

                      <button
                        className="slip-btn"
                        onClick={() => {
                          setSelectedEmi(emi,account);
                          printOrDownloadThermalSlip();
                        }}
                      >
                        Slip
                      </button> */}
                      <button
                        className="deposit-emi-reciept"
                        onClick={() =>
                          navigate("/Banking/DepositAccount/Depositemireciept", {
                            state: { account, emi,nextemi },
                          })
                        }
                      >
                        Receipt
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            )})
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No Installments Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

      {/* PAYMENT POPUP */}
      {showDialog && selectedEmi && (
        <div className="emi-dialog-overlay">
          <div className="emi-dialog-box">
            <h3>Pay Installment</h3>

            <p>
              <strong>Installment No:</strong> {selectedEmi.installmentNo}
            </p>
            {selectedEmi?.amount ? (
              <p>
                <strong>Amount:</strong> ₹{selectedEmi.amount}
              </p>
            ) : (
              ""
            )}
            <p>
              <strong>Due Date:</strong>{" "}
              {new Date(selectedEmi.dueDate).toLocaleDateString("en-GB")}
            </p>

            <div className="dialog-form">
              <label>Collection Date:</label>
              <input
                type="date"
                value={collectionDate}
                onChange={(e) => setCollectionDate(e.target.value)}
              />

              <label>Collection Mode:</label>
              <select
                value={collectionMode}
                onChange={(e) => setCollectionMode(e.target.value)}
              >
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Bank">Bank</option>
                <option value="Auto">Auto (Linked)</option>
              </select>

              <label>Amount:</label>
              {selectedEmi?.amount ? (
                <input type="text" value={selectedEmi.amount} readOnly />
              ) : (
                <input
                  type="text"
                  value={amount}
                  placeholder="Enter Amount"
                  onChange={(e) => setAmount(e.target.value)}
                />
              )}

              <label>Remarks:</label>
              <input
                type="text"
                placeholder="Remarks (optional)"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

            <div className="dialog-actions">
              <button
                className="confirm-btn"
                disabled={payLoading}
                onClick={async () => {
                  try {
                    setPayLoading(true);

                    const payload = {
                      accountId: account.id,
                      installmentNo: selectedEmi.installmentNo,
                      ...(account.accountType === "DD" && {
                        userAmount: amount,
                      }),
                      collectionDate,
                      collectionMode,
                      collectedBy: localStorage.getItem("userId") || 1,
                      remarks,
                    };

                    const url = "https://narrowitsolution.in/api/deposit/pay-installment";
                    // account.accountType === "RD"
                    //   ? "https://narrowitsolution.in/api/deposit/pay-installment"
                    //   : "https://narrowitsolution.in/api/deposit/pay-installment-custom";

                    const res = await axios.post(url, payload);

                    if (res.data.success) {
                      alert("Installment Paid Successfully!");
                      setShowDialog(false);
                      fetchData();
                    } else {
                      alert(res.data.message);
                    }
                  } catch (err) {
                    alert("Payment failed");
                  } finally {
                    setPayLoading(false);
                  }
                }}
              >
                {payLoading ? "Processing..." : "Pay Now"}
              </button>

              <button
                className="cancel-btn"
                onClick={() => setShowDialog(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Hidden thermal print container */}
       <div style={{ position: "absolute", left: "-10000px" }}>
          <div
            ref={slipRef}
            style={{
              width: "230px",           // 58mm thermal printer width
              padding: "10px",
              border:"1px solid #ccc",
              fontFamily: "Courier New, monospace",
              fontSize: "12px",
              lineHeight: "1.2",
            }}
          >


             <div style={{ textAlign: "center"}}>
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "14px" }}>
                    {company?company.name:"--"}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
                    <b>Contact No.:</b> {company?company.contact:"--"}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
                    <b>Address.:</b> {company?company.address:"--"}
                  </div>
              </div>


            <div style={{ textAlign: "center",marginTop:"10px", fontWeight: "bold", fontSize: "14px" }}>
             Deposit Payment Slip
            </div>

            <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>

            <div><b>Customer Name:</b> {account?.customerName}</div>
            <div><b>Account No.:</b> {account?.accountNo || "--"}</div>
            <div><b>Installment No.:</b> {selectedEmi?.installmentNo || "--"}</div>
            <div><b>Emi Amount:</b>{selectedEmi?.amount || "--"}</div>
            <div><b>Due Date:</b> {selectedEmi?.dueDate?
                                 new Date(selectedEmi.dueDate).toLocaleDateString("en-IN")
                                : "--"}</div>
            <div><b>Paid Date:</b>{selectedEmi?.collectionDate?
                                 new Date(selectedEmi.collectionDate).toLocaleDateString("en-IN")
                                : "--"}</div>
            <div><b>Payment Mode:</b> {selectedEmi?.collectionType || "--"}</div>
            <div><b>Status:</b> {selectedEmi?.status || "--"}</div>

            <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>

            <div style={{ textAlign: "center" }}>Thank you!</div>
            <div style={{ textAlign: "center" }}>--- {company ? company.name.split(" ")[0] : "End of "} Slip ---</div>
          </div>
       </div>
    </div>
  );
};



export default DepositEmiList;
